module.exports = __webpack_public_path__ + "img/txnNotStarted.01f5baa2.svg";